import * as actionTypes from "../constants";
import { ImportExportStatuses } from "../models";

import type { EncounterImportState } from "../models";

const createImportEncountersState = (): EncounterImportState => ({
  busy: false,
  taskId: null,
  status: null,
  error: null,
  result: null,
});

export const importEncountersReducer = (state = createImportEncountersState(), action) => {
  switch (action.type) {
    case actionTypes.ENCOUNTER_IMPORT_BEGIN_WAIT:
      return {
        ...state,
        busy: true,
      };
    case actionTypes.ENCOUNTER_IMPORT_END_WAIT:
      return {
        ...state,
        busy: false,
      };
    case actionTypes.ENCOUNTER_IMPORT_SET_STATUS:
      return {
        ...state,
        taskId: action.payload.JobId,
        status: action.payload.Status,
        error: action.payload.Error,
        result: action.payload.Result,
        busy: true,
      };
    case actionTypes.ENCOUNTER_IMPORT_CANCEL:
      return {
        ...state,
        taskId: null,
        status: null,
        error: null,
        result: null,
        busy: false,
      };
    case actionTypes.ENCOUNTER_IMPORT_SET_ERROR:
      return {
        ...state,
        status: ImportExportStatuses.Error,
        error: action.payload,
        busy: false,
      };
    case actionTypes.ENCOUNTER_IMPORT_CLEAR_ERROR:
      return {
        ...state,
        error: null,
        status: null,
      };

    default:
      return state;
  }
};
